<script lang="ts">
	import Image from '#components/image.svelte'
	import Shape from '#components/shape.svelte'
	import Video from '#components/video.svelte'

	let { shape, image, overlay, aspect, flip, shrink, fill, video } = $props()
	let Figure = $derived(shape ? Shape : Image)
</script>

<figure class="figure" class:flip class:shrink class:fill class:overlay={overlay?.filename}>
	{#if video?.m3u8_url}
		<Video {video} {aspect} />
	{:else if image?.filename}
		<Figure
			src={image.filename}
			alt={image.alt}
			focus={image.focus}
			name={shape}
			aspect={overlay?.filename ? '3/4' : aspect}
		/>
	{/if}
	{#if overlay?.filename}
		<Figure src={overlay.filename} alt={overlay.alt} focus={overlay.focus} name={shape} aspect="16/9" />
	{/if}
</figure>

<style lang="css">
	.figure {
		display: grid;
		max-width: 31.25rem;
		place-items: center;
		place-self: start center;
		width: 80%;

		@media (--from-mobile) {
			position: sticky;
			top: 6rem;
		}

		&.overlay {
			margin-block-end: var(--s-96);
			place-items: start;
			place-self: start;

			:global {
				.image {
					min-height: 0;
					max-width: 20rem;

					@media (--from-mobile) {
						max-width: 26rem;
					}
				}
			}

			&.flip {
				place-items: end;
				place-self: center end;

				:global {
					.image + .image {
						inset: auto auto 0 0;
						translate: -25% 40%;
					}
				}
			}
		}

		&.flip {
			@media (--from-mobile) {
				order: 2;
			}
		}

		&.shrink {
			max-width: 25rem;
		}

		&.fill {
			max-width: none;
			width: 100%;
		}

		/* @media (--until-mobile) {
			order: 1;
		} */

		:global {
			.shape {
				width: 100%;
			}

			.image {
				/* recently removed 18/08/25 */
				/* min-height: 20rem; */

				@media (--from-mobile) {
					/* recently removed 18/08/25 */
					/* min-height: 32rem; */
				}
			}

			.image + .image {
				inset: auto 0 0 auto;
				min-height: 0;
				max-width: 80%;
				position: absolute;
				translate: 25% 40%;
			}
		}
	}
</style>
